module.exports = __webpack_public_path__ + "static/Label_Example-0032f3bcb1543b116206904bfeec345e.pdf";